import { IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { Linked } from "@type-r/react";
import { CollapsableSection, Column, Flex, asDateTime } from "lqx-react/lib";
import React from "react";
import { Connection } from "../api/connection";
import { HeaderTitle } from "../components/asset-details-pane-styles";
import { CopyRow } from "../components/copy-row";
import { DetailsPaneActionsContainer, DetailsPaneContainer, DetailsPaneHeader, DetailsPaneStatus, DetailsPaneTab, DetailsPaneTabContent, DetailsPaneTabs, colorStyles, detailsPanelStyles } from "../components/item-card-styles";
import { ActivitiesTab } from "./activities-tab";
import { ConnectionsActions } from "./connections-actions";

export const ConnectionsDetailsPane = ({ $activeCard, $selectedTab }: { $activeCard: Linked<Connection>, $selectedTab: Linked<string> }) => {
    const classes = detailsPanelStyles();
    const colorClasses = colorStyles();

    const connectionStatus = () => $activeCard.value && $activeCard.value.isActive ? <span className={colorClasses.active}>Active</span> : <span className={colorClasses.inactive}>Inactive</span>

    return (
        <>
            <DetailsPaneContainer>
                <DetailsPaneHeader>
                    <IconButton aria-label="Close" size="small" className={classes.iconButton} onClick={() => $activeCard.set(null)}>
                        <CloseIcon />
                    </IconButton>
                    <Flex alignCenter>
                        <DetailsPaneStatus>{connectionStatus()}</DetailsPaneStatus>
                    </Flex>
                    <Flex>
                        <HeaderTitle><>Connection {$activeCard.value.id}</></HeaderTitle>
                    </Flex>
                </DetailsPaneHeader>
                <DetailsPaneActionsContainer>
                    <ConnectionsActions connection={$activeCard.value} />
                </DetailsPaneActionsContainer>
                <DetailsPaneTabs value={$selectedTab.value}
                    variant="scrollable"
                    scrollButtons="auto"
                    onChange={(evt, newValue) => $selectedTab.set(newValue)} >
                    <DetailsPaneTab value="details" label="Details" />
                    <DetailsPaneTab value="activities" label="Activities" />
                </DetailsPaneTabs>
                <DetailsPaneTabContent>
                    {$selectedTab.value === 'details' && <DetailsTab classes={classes} connection={$activeCard.value} />}
                    {$selectedTab.value === 'activities' && <ActivitiesTab connectionId={$activeCard.value.id} />}
                </DetailsPaneTabContent>
            </DetailsPaneContainer>
        </>
    )
};

const DetailsTab = ({ classes, connection }: { classes: any, connection: Connection }) => {
    return (
        <>
            <CollapsableSection title='General' titleClassName={classes.sectionTitle} noBorder noShadow >
                <Column>
                    <CopyRow label='Name' value={connection.name} />
                    <CopyRow label='Flow Direction' value={connection.flowType.name} />
                    <CopyRow label='Channel' value={connection.channelType.name} />
                    <CopyRow label='Asset Types' value={connection.fileCodes.join(', ')} />
                    <CopyRow label='Created By' value={connection.createdBy} />
                    <CopyRow label='Created On' value={asDateTime(connection.createdOn)} />
                    <CopyRow label='Updated On' value={asDateTime(connection.updatedOn)} />
                </Column>
            </CollapsableSection>
        </>
    )
};